import React from 'react';
import AsyncSearch from 'OldComponents/AsyncSearch/AsyncSearch';
import ReactSelect from 'react-select';
import ReactExport from 'react-export-excel';
import { DatePicker } from 'antd';
import moment from 'moment';
import TextField from '~/TextField/TextField.component';
import FielderButton from 'FielderComponents/FielderButton';
import Loading from '~/FielderElements/Loading/Loading';
import {
  Alert,
  Box,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { CloseRounded, DownloadOutlined } from '@mui/icons-material';
import { DashboardPaper, DashboardSectionTitle, DashboardTableWrapper } from './Dashboard.mui';
import { FielderHard, FielderPink } from '@core/theme/baseTheme';
import { SmartActionLabel } from '~/FielderElements/SmartTaskTable/SmartStyles';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const { RangePicker } = DatePicker;

const getDisabledDates = (current) => {
  const A_WEEK_OLD = moment().clone().subtract(10, 'days').startOf('day');
  const A_WEEK_IN_FUTURE = moment().clone().add(10, 'days').endOf('day');
  return current && !current.isBetween(A_WEEK_OLD, A_WEEK_IN_FUTURE);
};

const FilterChips = ({ cookieStorageFilter, loadAdvancedFilters, removeFilter }) => (
  <Stack direction='row' spacing={1} useFlexGap flexWrap='wrap'>
    {cookieStorageFilter.map((filter, i) => (
      <Chip
        key={`${filter.name}-tag-${i}`}
        label={filter.name}
        size='small'
        onClick={() => loadAdvancedFilters(i)}
        onDelete={() => removeFilter(i)}
        deleteIcon={<CloseRounded fontSize='small' />}
        sx={{
          borderRadius: 9999,
          height: 34,
          px: 1.5,
          bgcolor: FielderPink,
          color: 'grey.300',
          fontWeight: 600,
          fontSize: '1rem',
          '& .MuiChip-deleteIcon': {
            order: -1,
            mr: 1,
            ml: 0,
            color: 'grey.400',
            '&:hover': { color: 'grey.300' },
          },
          '& .MuiChip-label': {
            px: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
          '&:hover': { bgcolor: FielderHard },
        }}
        aria-label={`Filter ${filter.name}`}
      />
    ))}
  </Stack>
);

const CompanyTasksBrief = ({ dailyTaskByCompanies }) => (
  <TableBody>
    {dailyTaskByCompanies.map((company, index) => (
      <TableRow key={`TaskCompanyBranchResume-${index}`} hover>
        <TableCell align='center'>{company.companyName}</TableCell>
        <TableCell align='center'>{company.totalManaging}</TableCell>
        <TableCell align='center'>{company.totalAssignedToTeam}</TableCell>
        <TableCell align='center'>{company.totalAssignedToPartner}</TableCell>
        <TableCell align='center'>{company.totalWaitingAgent}</TableCell>
        <TableCell align='center'>{company.totalInProgress}</TableCell>
        <TableCell align='center'>{company.totalStartRoute}</TableCell>
        <TableCell align='center'>{company.totalArrived}</TableCell>
        <TableCell align='center'>{company.totalExecuting}</TableCell>
        <TableCell align='center'>{company.totalPause}</TableCell>
        <TableCell align='center'>{company.totalFinish}</TableCell>
        <TableCell align='center'>{company.totalCancel}</TableCell>
        <TableCell align='center'>{company.totalCount}</TableCell>
      </TableRow>
    ))}
  </TableBody>
);

const TaskCompanyBranchResume = (props) => {
  const {
    lan,
    renderDailyCompanyTask,
    dailyTaskByCompanies,
    setCompanyIds,
    getCompanyList,
    getInitialOptionsCompany,
    saveFilter,
    removeFilter,
    loadAdvancedFilters,
    updateViewSelect,
    cookieStorageFilter,
    showCookies,
    defaultCompanies,
    alertFilterText,
    showAlertTextFilter,
    closeFilterAlert,
    handleSelectBranch,
    branchesByCompany,
    showBranches,
    exportableDataCompanyHeaders,
    exportableDataCompany,
    downloadExcelDailyCompany,
    filterDates,
    changeDates,
  } = props;

  return (
    <DashboardPaper variant="outlined" sx={{ minHeight: 150 }}>
      <Grid container spacing={2} alignItems='center'>
        <Grid size='auto'>
          <DashboardSectionTitle>{lan.summaryOfTask}</DashboardSectionTitle>
        </Grid>
        <Grid size='auto'>
          <ExcelFile
            filename={lan.taskCompanyDashboard}
            element={<button id='myExcellCompany' hidden />}
          >
            <ExcelSheet data={exportableDataCompany} name={lan.task}>
              {exportableDataCompanyHeaders.map((col) => (
                <ExcelColumn key={col.label} label={col.label} value={col.key} />
              ))}
            </ExcelSheet>
          </ExcelFile>
        </Grid>
        {renderDailyCompanyTask && (
          <Grid size='auto'>
            <IconButton
              onClick={downloadExcelDailyCompany}
              size='small'
              aria-label={lan.export}
            >
              <DownloadOutlined />
            </IconButton>
          </Grid>
        )}
        {showAlertTextFilter && (
          <Grid size={12}>
            <Alert
              severity='success'
              onClose={closeFilterAlert}
              sx={{ width: '100%' }}
            >
              {alertFilterText}
            </Alert>
          </Grid>
        )}
      </Grid>

      <Grid container spacing={2} alignItems='center' sx={{ mt: 1 }}>
        <Grid size='auto'>
          <Typography>{`${lan.date.toUpperCase()}:`}</Typography>
        </Grid>
        <Grid size={8}>
          <RangePicker
            format='YYYY-MM-DD'
            placeholder={[lan.initialDate, lan.finalDate]}
            disabledDate={getDisabledDates}
            value={filterDates}
            onChange={changeDates}
          />
        </Grid>
      </Grid>

      <Stack spacing={2} sx={{ mt: 2 }}>
        {updateViewSelect && (
          <Grid container spacing={2} alignItems='center'>
            <Grid size='auto'>
              <Typography>{`${lan.searchByCompany}:`}</Typography>
            </Grid>
            <Grid size={8}>
              <AsyncSearch
                id='select-add-company'
                lan={lan}
                getOptions={getCompanyList}
                onChange={setCompanyIds}
                defaultValue={defaultCompanies}
                label={lan.placeHolderCompany}
                showInitialOptions
                getInitialOptions={getInitialOptionsCompany}
                multiple
                placeholder={`${lan.searchByCompany}:`}
                style={{ width: '100%' }}
              />
            </Grid>
          </Grid>
        )}
        {showBranches && (
          <Grid container spacing={2} alignItems='center'>
            <Grid size='auto'>
              <Typography>{`${lan.searchByBranch}:`}</Typography>
            </Grid>
            <Grid size={8}>
              <ReactSelect
                options={branchesByCompany}
                placeholder={lan.placeHolderBranch}
                onChange={handleSelectBranch}
                isMulti
                styles={{
                  container: (base) => ({ ...base, width: '100%' }),
                }}
                classNamePrefix="smart-select"
              />
            </Grid>
          </Grid>
        )}
      </Stack>

      <Grid container spacing={2} alignItems='center' sx={{ mt: 2 }}>
        <Grid size='auto'>
          <TextField id='txt-filter-name' label={lan.filterName} size='small' />
        </Grid>
        <Grid size='auto'>
          <FielderButton id='btn-save-filter' onClick={saveFilter}>
            {lan.saveFilter}
          </FielderButton>
        </Grid>
      </Grid>

      {showCookies && cookieStorageFilter.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <FilterChips
            cookieStorageFilter={cookieStorageFilter}
            loadAdvancedFilters={loadAdvancedFilters}
            removeFilter={removeFilter}
          />
        </Box>
      )}

      {renderDailyCompanyTask ? (
        <TableContainer component={DashboardTableWrapper} sx={{ mt: 3, maxHeight: 585 }}>
          <Table size='small' stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align='center'>{lan.company}</TableCell>
                <TableCell align='center'>{lan.taskStatus_0}</TableCell>
                <TableCell align='center'>{lan.taskStatus_9}</TableCell>
                <TableCell align='center'>{lan.taskStatus_8}</TableCell>
                <TableCell align='center'>{lan.taskStatus_3}</TableCell>
                <TableCell align='center'>{lan.taskStatus_4}</TableCell>
                <TableCell align='center'>{lan.taskStatus_6}</TableCell>
                <TableCell align='center'>{lan.taskStatus_10}</TableCell>
                <TableCell align='center'>{lan.taskStatus_5}</TableCell>
                <TableCell align='center'>{lan.taskStatus_15}</TableCell>
                <TableCell align='center'>{lan.taskStatus_2}</TableCell>
                <TableCell align='center'>{lan.taskStatus_1}</TableCell>
                <TableCell align='center'>{lan.grandTotal}</TableCell>
              </TableRow>
            </TableHead>
            <CompanyTasksBrief dailyTaskByCompanies={dailyTaskByCompanies} />
          </Table>
        </TableContainer>
      ) : (
        <Stack alignItems='center' spacing={1} sx={{ mt: 4 }}>
          <Loading inline size='40px' thickness={1} />
          <SmartActionLabel variant='caption'>{lan.loading}</SmartActionLabel>
        </Stack>
      )}
    </DashboardPaper>
  );
};

export default TaskCompanyBranchResume;
//Original code:
/*import React, { Component } from 'react';
import AsyncSearch from 'OldComponents/AsyncSearch/AsyncSearch';
import ReactExport from 'react-export-excel';
import { DatePicker } from 'antd';
import moment from 'moment';
import TextField from '~/TextField/TextField.component';
import FielderButton from 'FielderComponents/FielderButton';
import Loading from '~/FielderElements/Loading/Loading';
import { Chip, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { CloseRounded } from '@mui/icons-material';
import { FielderHard, FielderPink } from '@core/theme/baseTheme';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const { RangePicker } = DatePicker;
const CompanyTasksBrief = (props) => {
	const elements = props.dailyTaskByCompanies.map((company, index) => (
		<tr key={'TaskCompanyBranchResume-'+index}>
			<td className='text-center'>{company.companyName}</td>
			<td className='text-center'>{company.totalManaging}</td>
			<td className='text-center'>{company.totalAssignedToTeam}</td>
			<td className='text-center'>{company.totalAssignedToPartner}</td>
			<td className='text-center'>{company.totalWaitingAgent}</td>
			<td className='text-center'>{company.totalInProgress}</td>
			<td className='text-center'>{company.totalStartRoute}</td>
			<td className='text-center'>{company.totalArrived}</td>
			<td className='text-center'>{company.totalExecuting}</td>
			<td className='text-center'>{company.totalPause}</td>
			<td className='text-center'>{company.totalFinish}</td>
			<td className='text-center'>{company.totalCancel}</td>
			<td className='text-center'>{company.totalCount}</td>
		</tr>
	));
	return <tbody>{elements}</tbody>;
}
const getDisabledDates = (current) => {
	const A_WEEK_OLD = moment().clone().subtract(10, 'days').startOf('day');
	const A_WEEK_IN_FUTURE = moment().clone().add(10, 'days').endOf('day');
	return current && !current.isBetween(A_WEEK_OLD, A_WEEK_IN_FUTURE);
};
class TaskCompanyBranchResume extends Component {
	constructor(props) {
		super(props);
		this.initialState = {};
		this.state = this.initialState;
	}
  CookieFilter = () => (
    <Grid container spacing={1} alignItems="center">
      {this.props.cookieStorageFilter.map((filter, i) => (
        <Grid key={`${filter.name}-tag-${i}`} size="auto">
          <Chip
            label={filter.name}
            size={'small'}
            onClick={() => this.props.loadAdvancedFilters(i)}
            onDelete={() => this.props.removeFilter(i)}
            deleteIcon={<CloseRounded fontSize="small" />}
            variant="filled"
            sx={{
              borderRadius: 9999,
              height: 34,
              px: 1.25,
              bgcolor: FielderPink,
              color: 'grey.300',
              fontWeight: 600,
              fontSize: '1rem',
              '& .MuiChip-deleteIcon': {
                order: -1,
                mr: 1,
                ml: 0,
                color: 'grey.400',
                '&:hover': { color: 'grey.300' },
              },
              '& .MuiChip-label': {
                px: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
              '&:hover': { bgcolor: FielderHard },
            }}
            aria-label={`Filtro ${filter.name}`}
          />
        </Grid>
      ))}
    </Grid>
  );
	render() {
		return (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid size={12} container>
            <Grid size={'auto'}><Typography>{this.props.lan.summaryOfTask}</Typography></Grid>
            <Grid size={'auto'}>
              <ExcelFile
                filename={this.props.lan.taskCompanyDashboard}
                element={<button id='myExcellCompany' hidden></button>}
              >
                <ExcelSheet
                  data={this.props.exportableDataCompany}
                  name={this.props.lan.task}
                >
                  {this.props.exportableDataCompanyHeaders.map((col) => <ExcelColumn key={col.label} label={col.label} value={col.key} />)}
                </ExcelSheet>
              </ExcelFile>
            </Grid>
            {this.props.renderDailyCompanyTask && (
              <Grid size={'auto'}>
                <img
                  src={`${process.env.AWS_FIELDER_ICONS}import-icon.svg`}
                  className='icon Fielder-icon-button'
                  alt='Exportar'
                  title={this.props.lan.export}
                  style={{ marginTop: '-5px' }}
                  onClick={this.props.downloadExcelDailyCompany}
                  id='id-export-agent'
                />
              </Grid>
            )}
            <Grid size={'auto'}>
              {this.props.showAlertTextFilter && (
                <div className='alert alert-success alert-dismissible fade show' role='alert'>
                  {this.props.alertFilterText}
                  <button
                    type='button'
                    className='close'
                    data-dismiss='alert'
                    aria-label='Close'
                    onClick={this.props.closeFilterAlert}
                  >
                    <span aria-hidden='true'>&times;</span>
                  </button>
                </div>
              )}
            </Grid>
          </Grid>
          <Grid size={12} container>
            <Grid size={'auto'}>
              {this.props.lan.date.toUpperCase()+': '}
            </Grid>
            <Grid size={8}>
              <RangePicker
                format='YYYY-MM-DD'
                placeholder={[this.props.lan.initialDate, this.props.lan.finalDate]}
                disabledDate={getDisabledDates}
                value={this.props.filterDates}
                onChange={this.props.changeDates}
                {...this.props}
              />
            </Grid>
          </Grid>
          <Grid size={12} container>
            {this.props.updateViewSelect && (
              <Grid size={12} container>
                <Grid size={'auto'}>
                  {`${this.props.lan.searchByCompany}:`}
                </Grid>
                <Grid size={8}>
                  <AsyncSearch
                    id='select-add-company'
                    lan={this.props.lan}
                    getOptions={this.props.getCompanyList}
                    onChange={this.props.setCompanyIds}
                    defaultValue={this.props.defaultCompanies}
                    label={this.props.lan.placeHolderCompany}
                    showInitialOptions
                    getInitialOptions={this.props.getInitialOptionsCompany}
                    multiple
                    placeholder={`${this.props.lan.searchByCompany}:`}
                  />
                </Grid>
              </Grid>
            )}
            {this.props.showBranches && (
              <Grid size={12} container>
                <Grid size={'auto'}>
                  {`${this.props.lan.searchByBranch}:`}
                </Grid>
                <Grid size={8}>
                  <ReactSelect
                    variant='outlined'
                    options={this.props.branchesByCompany}
                    placeholder={this.props.lan.placeHolderBranch}
                    onChange={this.props.handleSelectBranch}
                    isMulti
                    fullWidth
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid size={12} container style={{alignItems: 'center'}}>
            <Grid size={12} container>
              <Grid size={'auto'}>
                <TextField id='txt-filter-name' label={this.props.lan.filterName} size='small' />
              </Grid>
              <Grid size={'auto'}>
                <FielderButton id='btn-save-filter' onClick={this.props.saveFilter} >
                  {this.props.lan.saveFilter}
                </FielderButton>
              </Grid>
            </Grid>
            {this.props.showCookies &&
              <Grid size={12}>
                <this.CookieFilter cookieStorageFilter={this.props.cookieStorageFilter} />
              </Grid>
            }
          </Grid>
          {this.props.renderDailyCompanyTask ? (
            <Grid size={12} container>
              <div className='Dashboard-tasksBrief-table mt-2'>
                <div className='table-responsive-sm'>
                  <table className='table table-sm table-hover'>
                    <thead>
                    <tr>
                      <th scope='col-auto'>{this.props.lan.company}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_0}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_9}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_8}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_3}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_4}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_6}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_10}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_5}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_15}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_2}</th>
                      <th scope='col-auto'>{this.props.lan.taskStatus_1}</th>
                      <th scope='col-auto'>{this.props.lan.grandTotal}</th>
                    </tr>
                    </thead>
                    <CompanyTasksBrief dailyTaskByCompanies={this.props.dailyTaskByCompanies} />
                  </table>
                </div>
              </div>
            </Grid>
          ) : (
            <Grid size={12} container direction="row" sx={{ justifyContent: "center", alignItems: "center", }}>
              <Grid size={'auto'}><Loading inline size="40px" thickness={1} /></Grid>
              <Grid size={8}>{this.props.lan.loading}</Grid>
            </Grid>
          )}
        </Grid>
      </Paper>
		);
	}
}
export default TaskCompanyBranchResume;*/
